import { render } from "./AppCircleBtn.vue?vue&type=template&id=52f5fe2d&scoped=true"
import script from "./AppCircleBtn.vue?vue&type=script&lang=js"
export * from "./AppCircleBtn.vue?vue&type=script&lang=js"

import "./AppCircleBtn.vue?vue&type=style&index=0&id=52f5fe2d&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f5fe2d"]])

export default __exports__